module.exports = __webpack_public_path__ + "img/Modernisme_Musikk2.bef99831.jpg";